import { Box, Card, IconButton } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import { Doughnut } from 'react-chartjs-2'
import { Bar } from 'react-chartjs-2'
import moment from 'moment'
import 'moment/locale/fr'
import BarCIcone from '../Icone/bar_chart_white_24dp.svg'
import DonutCIcone from '../Icone/donut_small_white_24dp.svg'
import { sum } from 'lodash'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
function PatrimoineNetCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [click, setClick] = useState(false)
  const [optionChart, setOptionChart] = useState(false)
  const [revdataBar, setRevDataBar] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
    total: 0,
  })

  const [revData, setRevData] = useState({
    labels: oldData?.label,
    datasets: [
      {
        data: oldData?.data,

        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
    total: 0,
  })
  const optiondonut = {
    responsive: true,
    aspectRatio: 1.3,
    clip: true,

    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value] + ' %'
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: true,
        position: 'bottom',
        responsive: true,
        events: [],
        labels: {
          boxWidth: 10,
        },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  const color_list = [
    '#4e92cf',
    '#48ad51',
    '#295a9c',
    '#bf9637',
    '#6c685f',
    '#aec0e3',
    '#cc5ccd',
    '#bbcd5c',
  ]
  useEffect(() => {
    setRevDataBar({
      labels: oldData?.year_labels,
      datasets: oldData?.by_year.map((el, index) => ({
        label: el.type,
        data: el.data,
        backgroundColor: [color_list[index]],
        borderColor: [color_list[index]],
        borderWidth: 1,
      })),
      total: oldData?.total,
      last_year: oldData?.last_year,
    })
    setRevData({
      labels: oldData?.repartition?.labels,
      datasets: [
        {
          data: oldData?.repartition?.data,

          backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
      total: oldData?.total,
    })
  }, [oldData])

  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    aspectRatio: 1,

    onClick: function (evt, element) {
      if (click) {
        setClick(false)

        setRevDataBar({
          labels: oldData?.year_labels,
          datasets: oldData?.by_year.map((el, index) => ({
            label: el.type,
            data: el.data,
            backgroundColor: [color_list[index]],
            borderColor: [color_list[index]],
            borderWidth: 1,
          })),
          total: oldData?.total,
          last_year: oldData?.last_year,
        })
      } else {
        setClick(true)
        if (element.length > 0) {
          let catName = revdataBar.labels[element[0].index]

          let data = oldData?.by_month
          data = data.filter((v) => v.year === catName)

          let last_month = 100

          if (data.length > 2) {
            let n2 = data.at(-2).data
            let n1 = data.at(-1).data
            // console.log(sum(n1))
            // console.log(sum(n2))
            last_month = ((sum(n1) - sum(n2)) / sum(n2)) * 100
          }

          let labels = []

          let cat_labels = oldData?.cat_labels

          data.forEach((item, i) => {
            labels.push(moment(item.date).format('MMM YY'))
          })
          let re_cat_data = []
          cat_labels.forEach((e, i) => {
            let val = []
            data.forEach((d, di) => {
              val.push(d.data[i])
            })
            re_cat_data.push({ type: e, data: val })
          })

          let new_cat_data = []
          re_cat_data.forEach((e) => {
            if (sum(e.data) !== 0) {
              new_cat_data.push(e)
            }
          })
          if (isNaN(last_month)) last_month = 0
          setRevDataBar({
            labels: labels,
            datasets: new_cat_data.map((el, index) => ({
              label: el.type,
              data: el.data,
              backgroundColor: [color_list[index]],
              borderColor: [color_list[index]],
              borderWidth: 1,
            })),
            total: oldData?.total,
            last_year: last_month,
          })
        }
      }
    },

    elements: {
      bar: {
        borderWidth: 2,
      },
    },

    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: true,
        position: 'right',
        labels: {
          boxWidth: 10,
          color: 'white',
        },
      },

      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
        bodyFont: {
          size: 14,
          color: 'white',
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: 'white' },
      },
      y: {
        stacked: true,
        ticks: { color: 'white' },
      },
    },
  }
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.patrimoineEvolution')}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {revdataBar?.total}

            <WTypography
              component={'span'}
              sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
            >
              €
            </WTypography>
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {optionChart
              ? t('monPatrimoine.patrimoineDistribution')
              : click
              ? t('monPatrimoine.monthlyEvolution')
              : t('monPatrimoine.annualEvolution')}
          </WTypography>
          <WTypography component={'span'} variant="body2">
            {optionChart ? '' : parseFloat(revdataBar?.last_year).toFixed(2)}

            <WTypography
              component={'span'}
              sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
            >
              {optionChart ? '' : '%'}
            </WTypography>
          </WTypography>
        </Box>

        <Box minWidth={3} mb={8} height={'100%'} className="no-drag">
          {optionChart ? (
            <Box mt={9} className="chart_box" minWidth={3} mb={6} height={'100%'}>
              <Doughnut data={revData} options={optiondonut} />
            </Box>
          ) : (
            <Box mt={4} className="chart_box" minWidth={3} mb={6}>
              <Bar data={revdataBar} options={optionsbar} />
            </Box>
          )}
        </Box>
        {/* <Box mt={2} className="dashboard_card__filters1">
          <Box>
            {optionChart ? (
              <IconButton onClick={() => setOptionChart(false)}>
                <img src={BarCIcone} alt="BarChart" className="Optionbutton"></img>
              </IconButton>
            ) : (
              <IconButton onClick={() => setOptionChart(true)}>
                <img src={DonutCIcone} alt="DonutChart" className="Optionbutton"></img>
              </IconButton>
            )}
          </Box>
        </Box> */}
      </Card>
    </>
  )
}

export default PatrimoineNetCard
